import React from 'react';

const CheckBoxAlt = ({ size = 1 }: { size?: number }) => (
  <svg width={`${size}em`} viewBox="0 0 18 18">
    <g transform="translate(1.9 1.9)">
      <path
        d="m2 0c-1.11 0-2 0.892-2 2v10.2c0 1.11 0.892 2 2 2h10.2c1.11 0 2-0.892 2-2v-10.2c0-1.11-0.892-2-2-2zm1.5 5.6h7.2a1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5h-7.2a1.5 1.5 0 0 1-1.5-1.5 1.5 1.5 0 0 1 1.5-1.5z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default CheckBoxAlt;
